export default __webpack_public_path__ + "images/0x17af1df44444ab9091622e4aa66db5bb34e51ad5.png";